export const PRICE_MAX_LENGTH = 20;
